import React from 'react';
import PropTypes from 'prop-types';
import HomePage from '@components/home-page';

const FrenchHomePage = ({ location }) => <HomePage location={location} language="fr" />;

FrenchHomePage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default FrenchHomePage;
